import { render } from "./AttrChat.vue?vue&type=template&id=2ac66380&scoped=true"
import script from "./AttrChat.vue?vue&type=script&lang=js"
export * from "./AttrChat.vue?vue&type=script&lang=js"

import "./AttrChat.vue?vue&type=style&index=0&id=2ac66380&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac66380"],['__file',"src/components/widgets/components_core/AttrChat.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ac66380"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ac66380', __exports__)) {
    api.reload('2ac66380', __exports__)
  }
  
  module.hot.accept("./AttrChat.vue?vue&type=template&id=2ac66380&scoped=true", () => {
    api.rerender('2ac66380', render)
  })

}


export default __exports__